import { styled } from '@mui/material/styles'
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox'
import Check from '../assets/svgs/Check.svg'

const StyledIcon = styled('span')(({ theme }) => ({
  width: 20,
  height: 20,
  padding: 2,
  border: 'solid',
  borderWidth: 2,
  borderRadius: 4,
  borderColor: theme.palette.primary[300],
  backgroundColor: 'transparent',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:disabled ~ &': {
    background: theme.palette.primary[300],
  },
}))

const StyledCheckedIcon = styled(StyledIcon)(({ theme }) => ({
  borderColor: theme.palette.secondary.main,
  backgroundColor: theme.palette.secondary.main,
  '&:before': {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    display: 'block',
    width: 12,
    height: 12,
    backgroundImage: `url(${Check})`,
    content: '""',
  },
}))

export const ThemedCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      className="checkbox"
      disableRipple
      color="secondary"
      checkedIcon={<StyledCheckedIcon />}
      icon={<StyledIcon />}
      sx={{
        padding: '12px',
        paddingTop: '0.9rem',
        paddingBottom: '0.9rem',
      }}
      inputProps={{ 'aria-label': 'Checkbox' }}
      {...props}
    />
  )
}
